import CardHeader from "components/CardHeader";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { useDashboardData } from "./DashboardData";
import { upcomingAssetServices } from "./dashboardOperationalData";

interface Props {
    daysAhead?: number;
}

const UpcomingAssetServicesCard: React.FC<Props> = ({ daysAhead = 30 }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const { assets, assetsFailed: failed, assetsLoading: loading } = useDashboardData();
    const services = useMemo(() => upcomingAssetServices(assets, daysAhead), [assets, daysAhead]);
    const formatDate = (date: Date) => new Intl.DateTimeFormat(intlLocale, { dateStyle: "medium" }).format(date);

    return <Card className="h-100 mb-0 dashboard-widget-card">
        <CardBody>
            <CardHeader
                title={t("dashboard.upcomingAssetServicesCard.title")}
                icon="mdi-calendar-clock"
                count={services.length}
                actions={<Link to="/assets" className="btn btn-sm btn-light" aria-label={t("dashboard.upcomingAssetServicesCard.openAssets")}>
                    <i className="mdi mdi-arrow-right" aria-hidden="true" />
                </Link>}
            />
            {loading && <p className="text-muted mt-3 mb-0">{t("dashboard.upcomingAssetServicesCard.loading")}</p>}
            {failed && <p className="text-danger mt-3 mb-0">{t("dashboard.upcomingAssetServicesCard.loadFailed")}</p>}
            {!loading && !failed && services.length === 0 && <p className="text-muted mt-3 mb-0">
                {t("dashboard.upcomingAssetServicesCard.empty", { count: daysAhead })}
            </p>}
            {!loading && !failed && <div className="dashboard-widget-scroll dashboard-operational-list">
                {services.map(({ asset, interval, scheduledAt }) => <Link
                    className="dashboard-operational-row text-body text-decoration-none"
                    key={`${asset.id}-${interval.id}`}
                    to={`/assets/${asset.id}`}
                >
                    <span className="min-w-0">
                        <strong className="d-block text-truncate">{interval.name}</strong>
                        <small className="text-muted d-block text-truncate">{asset.name}</small>
                    </span>
                    <time className="small text-muted flex-shrink-0" dateTime={scheduledAt.toISOString()}>{formatDate(scheduledAt)}</time>
                </Link>)}
            </div>}
        </CardBody>
    </Card>;
};

export default UpcomingAssetServicesCard;
